import { writable } from 'svelte/store';

// Preserve the existing pathname URLs used by Microsoft redirects and shared CV links.
export const routePath = writable(window.location.pathname);
window.addEventListener('popstate', () => routePath.set(window.location.pathname));

export function navigate(path: string, options: { replace?: boolean } = {}): void {
  const target = new URL(path, window.location.href);
  if (target.origin !== window.location.origin) {
    window.location.assign(target.href);
    return;
  }
  const method = options.replace ? 'replaceState' : 'pushState';
  window.history[method]({}, '', target.pathname + target.search + target.hash);
  routePath.set(target.pathname);
  window.scrollTo(0, 0);
}
